"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Wrapper = (0, _styledComponents["default"])("div").withConfig({
  displayName: "select__Wrapper",
  componentId: "sc-143d6q2-0"
})(["display:inline-block;position:relative;"]);
var Control = (0, _styledComponents["default"])("div").withConfig({
  displayName: "select__Control",
  componentId: "sc-143d6q2-1"
})(["align-items:center;border:1px solid ", ";cursor:pointer;display:flex;justify-content:space-between;padding:5px 10px;"], function (props) {
  return (0, _styles.colors)("grey-migration", props);
});
var ControlArrowUp = (0, _styledComponents["default"])("div").withConfig({
  displayName: "select__ControlArrowUp",
  componentId: "sc-143d6q2-2"
})(["border-bottom:5px solid ", ";border-left:5px solid transparent;border-right:5px solid transparent;height:0;margin-left:5px;width:0;"], function (props) {
  return (0, _styles.colors)("title-black", props);
});
var ControlArrowDown = (0, _styledComponents["default"])("div").withConfig({
  displayName: "select__ControlArrowDown",
  componentId: "sc-143d6q2-3"
})(["border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid ", ";height:0;margin-left:5px;width:0;"], function (props) {
  return (0, _styles.colors)("title-black", props);
});
var Option = (0, _styledComponents["default"])("div").withConfig({
  displayName: "select__Option",
  componentId: "sc-143d6q2-4"
})(["padding:10px 15px;&:hover{background-color:", ";}"], function (props) {
  return (0, _styles.colors)("ultra-light-grey", props);
});
var Menu = (0, _styledComponents["default"])("div").withConfig({
  displayName: "select__Menu",
  componentId: "sc-143d6q2-5"
})(["border:1px solid ", ";border-top:none;background-color:", ";cursor:pointer;left:0;position:absolute;top:100%;width:100%;"], function (props) {
  return (0, _styles.colors)("grey", props);
}, function (props) {
  return (0, _styles.colors)("white", props);
});
var propTypesOptions = {
  children: _propTypes.node,
  onClick: _propTypes.func,
  options: (0, _propTypes.arrayOf)(_propTypes.node)
};

var Options = function Options(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      options = _ref.options;
  return options ? /*#__PURE__*/_react["default"].createElement(Menu, null, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: option,
      onClick: function onClick() {
        return _onClick(option);
      }
    }, option);
  })) : children({
    onClick: _onClick
  });
};

Options.propTypes = propTypesOptions;

var Select = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Select, _Component);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      opened: false
    };

    _this.open = function () {
      _this.setState({
        opened: true
      });
    };

    _this.close = function () {
      _this.setState({
        opened: false
      });
    };

    _this.selectOnClick = function (value) {
      var onChange = _this.props.onChange;

      _this.setState({
        opened: false
      });

      if (onChange) {
        onChange(value);
      }
    };

    return _this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        value = _this$props.value;
    var opened = this.state.opened;
    return /*#__PURE__*/_react["default"].createElement(Wrapper, {
      className: className
    }, /*#__PURE__*/_react["default"].createElement(Control, {
      onClick: opened ? this.close : this.open,
      opened: opened
    }, value || placeholder, /*#__PURE__*/_react["default"].createElement("div", null, opened ? /*#__PURE__*/_react["default"].createElement(ControlArrowUp, null) : /*#__PURE__*/_react["default"].createElement(ControlArrowDown, null))), opened ? /*#__PURE__*/_react["default"].createElement(Options, {
      onClick: this.selectOnClick,
      options: options
    }, children) : null);
  };

  return Select;
}(_react.Component);

Select.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  onChange: _propTypes.func,
  options: (0, _propTypes.arrayOf)(_propTypes.node),
  placeholder: _propTypes.string,
  value: _propTypes.string
};
Select.defaultProps = {
  placeholder: ""
};
var _default = Select;
exports["default"] = _default;